import React, {Component} from 'react';

import {ToastsStore} from 'react-toasts';
import {PrConnect} from '../../../../library/pr-miniredux';
import UploadPopup from './uploadPopup'
import AWS from "aws-sdk";
import $ from "jquery";


export class UploadPopupCtrl extends Component {
    constructor(props) {
        super(props);
        console.log("props");
        console.log(props);

        this.state = {
            showSuccessMessage: "none",
            showUploadSection: "block",
            showWaitForFileUpload: "block",
            filesToUpload: this.props.componentprops.filesToUpload,
            currentCount:'',
            totalCount:'',
            currentFileName:''
        };
        //this.HandleFileUploadCompletion = this.HandleFileUploadCompletion.bind(this);
    }


    UNSAFE_componentWillMount = () => {
        console.log("this.props.componentprops.filesToUpload: "+this.props.componentprops.filesToUpload)
        console.log("this.state.fileToUpload: "+this.state.filesToUpload)
        let totalCount = this.state.filesToUpload.length
        this.setState({
            currentCount: 1,
            totalCount: totalCount
        })

        this.UploadFiles()


    };


    UploadFiles = () => {

        this.state.showUploadPopup = true;

        this.FileUploadToS3(this.state.filesToUpload[0], 0);
        //this.FileUploadToS3New(this.state.filesToUpload[0], 0);
    };


    FileUploadToS3 = (item, uploadedFilesCount) => {
        AWS.config.update({
            accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
            secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY
        })

        //AWS.config.httpOptions.timeout= 120000
        //AWS.config.httpOptions.configxhrWithCredentials = true;

        const myBucket = new AWS.S3({
            params: { Bucket: process.env.REACT_APP_AWS_BUCKET},
            region: process.env.REACT_APP_AWS_REGION,
        })

        let that = this
        //let id = e.target.id
        let fileName = item["fileName"];
        this.setState({
            currentFileName: fileName,
            currentCount: uploadedFilesCount+1
        });

        console.log("fileName: "+fileName)
        console.log("that.state.currentCount: "+that.state.currentCount)
        that.state.currentFileName = fileName;
        that.state.showWaitForFileUpload = "block";

        const params = {
            //ACL: 'public-read',
            ACL: 'private',
            Key: item["modifiedFileName"],
            ContentType: item["type"],
            ContentLength: item["size"],
            Body: item["file"],
            //Body: arrayBuffer,
            //ContentDisposition: contentDeposition
        }

        //window["s3upload"](e.target.files);

        //var options = {partSize: 100 * 1024 * 1024, queueSize: 1};
        AWS.config.httpOptions.timeout = 0;
        //AWS.config.httpOptions.async = true;

        $("#progress").css("display", "block");



        myBucket.putObject(params)
            //.on('httpUploadProgress', ({ loaded, total }) => {
            .on('httpUploadProgress', ({ loaded, total }) => {
                //console.log(evt);
                console.log('Progress:', loaded, '/', total, `${Math.round(100 * loaded / total)}%`);
                let uploaded = Math.round(100 * loaded / total)

                var progressBar     = document.querySelector(".progress-bar");
                progressBar.style.width = uploaded + "%";
                progressBar.textContent = uploaded + "%";
            }).on("success", (evt) => {
                uploadedFilesCount = uploadedFilesCount+1
                console.log("success")
                $("#nextPageBtn").prop("disabled",false);
                ToastsStore.success("File Successfully Uploaded.");
                //document.getElementById("progress-bar-label_"+id).style.display = "none";//TO_DO
                console.log(evt)

                var progressBar     = document.querySelector(".progress-bar");
                progressBar.style.width = 0 + "%";
                progressBar.textContent = 0

                if(Number(that.state.filesToUpload.length) == uploadedFilesCount){
                    console.log("=======================Inside if (success) =====================")
                    that.state.showWaitForFileUpload = "none";
                    that.props.componentprops.HandleFileUploadCompletion(true);
                }else{
                    console.log("=======================Inside else (success) =====================")
                    that.state.currentCount = Number(that.state.currentCount)+1;
                    that.FileUploadToS3(this.state.filesToUpload[uploadedFilesCount], uploadedFilesCount)
                }


                //this.onFileUploadSuccess(questionItem, item, fileName)
            }).send((err) => {
                if (err) {
                    console.log("error: "+err)
                    // handle the error here
                }
            })
    }


    render() {
        return (
            <div>
                    <UploadPopup {...this.props} state={this.state}
                                 HandleFileUploadCompletion={this.HandleFileUploadCompletion}
                           />
            </div>

        )
    }
}

export default UploadPopupCtrl = PrConnect(UploadPopupCtrl, '');